<template>
  <div id="app">
    <el-scrollbar class="app_container my_scrollbar">
      <router-view />
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: "app",
  metaInfo: {
    titleTemplate: "电喵科技 ｜ %s",
    meta: [
      { name: "description", content: "江苏电喵科技公司官网，一家专注于新能源充电智能管控方案的公司" },
      { name: "keywords", content: "新能源汽车,充电场站,停车场智能管控,江苏电喵,电喵科技,江苏电喵科技官网,电喵官网" },
      { name: "baidu-site-verification", content: "codeva-18v0utvVlJ" },
    ],
  },
  components: {},
  data() {
    return {};
  },
  created() {
    // 禁用浏览器返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  methods: {
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
    // 跳转页面
    goPage(val) {
      const { href } = this.$router.resolve({
        path: url, // 你想跳转到的路径
        query: { index: index }, // 可选，带 query 参数
      });
      const fullUrl = window.location.origin + href;
      window.open(fullUrl, "_blank");
    },
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;

  .app_container {
    min-width: 960px;
    position: relative;
  }
}
</style>
